import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { GameBase } from '../../games/game-base';
import { BaccaratTableComponent } from '../../games/main-games/baccarat/baccarat-table.component';
import { DragonTigerTableComponent } from '../../games/main-games/dragon-tiger/dragon-tiger-table.component';
import { ThreeHeadedDragonTableComponent } from '../../games/main-games/three-headed-dragon/three-headed-dragon-table.component';
import { GameType } from '../../models/communication/app-enums.model';

@Component({
    selector: 'app-game-switch',
    standalone: true,
    imports: [CommonModule, DragonTigerTableComponent, BaccaratTableComponent, ThreeHeadedDragonTableComponent],
    templateUrl: './game-switch.component.html',
    styleUrl: './game-switch.component.scss'
})
export class GameSwitchComponent implements OnInit {
    @Input()
    gameType?: GameType;

    @Input()
    gameInstance?: GameBase;

    protected readonly GameType = GameType;

    ngOnInit(): void {
        if (!this.gameType || !this.gameInstance) {
            // eslint-disable-next-line no-console
            console.error('gameType or gameInstance not provided');
        }
    }
}
